'use strict';
angular.module('resWeiboRouter', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('front.networksource.classifiedresource.weibo.resource', {
            url: '/resource?acode&media_id&fcode&hybase_id&param_data&medianame',
            views: {
                'networksource@front.networksource.classifiedresource.weibo': {
                    templateUrl: './networkResource/classifiedResource/weibo/weibo_tpl.html',
                    controller: 'resCenNewWeiboCtrl',
                },
            },
        });
    },
]);
